import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import {
  Box,
  Typography,
  Paper,
  CardMedia,
  CardContent,
  Chip,
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  styled,
  Divider,
  Stack,
  Button,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import BathtubIcon from "@mui/icons-material/Bathtub";
// import HotelIcon from "@mui/icons-material/Hotel";
import BedIcon from "@mui/icons-material/Bed";
import SquareFootIcon from "@mui/icons-material/SquareFoot";
import ChevronLeft from "@mui/icons-material/ChevronLeft";
import ChevronRight from "@mui/icons-material/ChevronRight";
import FullscreenIcon from "@mui/icons-material/Fullscreen";
import { useState } from "react";
import makeFullUrl from "../../utils/cloudinary";
import PriceDisplay from "../PriceDisplay";
import { InfoOutlined } from "@mui/icons-material";
import UnitDetailsDialog from "./UnitDetailsDialog";

const PropertyItem = styled(Paper)(({ theme }) => ({
  position: "relative",
  overflow: "hidden",
  transition: "transform 0.3s",
  // "&:hover": {
  //   transform: "translateY(-5px)",
  // },
  borderRadius: "8px",
}));

// Comments styled component for consistent height
const CommentTeaser = styled(Typography)(({ theme }) => ({
  marginTop: theme.spacing(1),
  color: theme.palette.text.secondary,
  display: "-webkit-box",
  WebkitLineClamp: 1, // Strict 1-line limit
  WebkitBoxOrient: "vertical",
  overflow: "hidden",
  textOverflow: "ellipsis",
  minHeight: "1.5em", // Reserves space even if empty to keep cards aligned
  fontSize: "0.875rem",
}));

const PublicUnitCard = ({ unit, property }) => {
  const [selectedUnit, setSelectedUnit] = useState(null);
  const [isGalleryOpen, setIsGalleryOpen] = useState(false);
  const [activeImageIndex, setActiveImageIndex] = useState(0);
  const [detailsOpen, setDetailsOpen] = useState(false);

  // Custom arrow components
  const SampleNextArrow = (props) => {
    const { onClick } = props;
    return (
      <IconButton
        onClick={onClick}
        sx={{
          position: "absolute",
          right: 8,
          top: "50%",
          transform: "translateY(-50%)",
          zIndex: 1,
          color: "white",
          bgcolor: "rgba(0,0,0,0.5)",
          "&:hover": { bgcolor: "rgba(0,0,0,0.8)" },
        }}
      >
        <ChevronRight fontSize="large" />
      </IconButton>
    );
  };

  const SamplePrevArrow = (props) => {
    const { onClick } = props;
    return (
      <IconButton
        onClick={onClick}
        sx={{
          position: "absolute",
          left: 8,
          top: "50%",
          transform: "translateY(-50%)",
          zIndex: 1,
          color: "white",
          bgcolor: "rgba(0,0,0,0.5)",
          "&:hover": { bgcolor: "rgba(0,0,0,0.8)" },
        }}
      >
        <ChevronLeft fontSize="large" />
      </IconButton>
    );
  };

  const dialogSliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    beforeChange: (current, next) => setActiveImageIndex(next),
    appendDots: (dots) => (
      <div
        style={{
          position: "absolute",
          bottom: "10px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "100%",
        }}
      >
        <ul style={{ margin: 0, padding: 0 }}>{dots}</ul>
      </div>
    ),
    customPaging: (i) => (
      <div
        style={{
          width: "10px",
          height: "10px",
          borderRadius: "50%",
          backgroundColor:
            i === activeImageIndex ? "#fff" : "rgba(255,255,255,0.5)",
          margin: "0 4px",
          cursor: "pointer",
        }}
      />
    ),
  };

  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
    beforeChange: (current, next) => setActiveImageIndex(next),
    appendDots: (dots) => (
      <div
        style={{
          position: "absolute",
          bottom: "10px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "100%",
        }}
      >
        <ul style={{ margin: 0, padding: 0 }}>{dots}</ul>
      </div>
    ),
  };

  const formattedPrice = new Intl.NumberFormat("en-AE", {
    style: "currency",
    currency: "AED",
    minimumFractionDigits: unit.price % 1 !== 0 ? 2 : 0, // Ensures two decimal places if available
    maximumFractionDigits: 2, // Limits to two decimal places
  }).format(unit.price);

  // List of Payment Fequency for dropdown menu
  const paymentFrequencyArray = [
    { key: "monthly", value: "Monthly" },
    { key: "yearly", value: "Yearly" },
    { key: "daily", value: "Daily" },
  ];

  // List of Bedrooms for dropdown menu
  const bedroomsArray = [
    { key: "studio", value: "Studio" },
    { key: "1", value: "1" },
    { key: "2", value: "2" },
    { key: "3", value: "3" },
    { key: "4", value: "4" },
    { key: "5", value: "5" },
    { key: "5+", value: "5+" },
  ];

  const bathroomTypeArray = [
    { key: "attached", value: "Attached" },
    { key: "common", value: "Common" },
    // { key: "shared", value: "Shared" },
    { key: "2", value: "2" },
    { key: "3", value: "3" },
    { key: "4", value: "4" },
    { key: "5", value: "5" },
    { key: "5+", value: "5+" },
  ];

  // Helper function to get the display value from a key
  const getDisplayValue = (key, options) => {
    const option = options.find((opt) => opt.key === key);
    return option ? option.value : key; // Fallback to key if no match is found
  };

  const getOrderedImages = (unit) => {
    // Safely extract main image path
    const mainImagePath = unit.mainImage?.filePath
      ? // ? `${process.env.REACT_APP_SERVER_URL}/${unit.mainImage.filePath}`
        makeFullUrl(unit.mainImage.filePath, unit.mainImage.fileType)
      : // : unit.mainImage.url;
        URL.createObjectURL(unit.mainImage.file);

    // Safely extract image paths with error filtering
    const imagePaths = (unit.images || []).flatMap((image) =>
      image?.filePath
        ? // ? [`${process.env.REACT_APP_SERVER_URL}/${image.filePath}`]
          [makeFullUrl(image.filePath, image.fileType)]
        : // : [image.file]
          [URL.createObjectURL(image.file)]
    );

    // Merge with main image first (if exists)
    return mainImagePath ? [mainImagePath, ...imagePaths] : imagePaths;
  };

  return (
    <>
      <PropertyItem elevation={3}>
        {/* Image Slider */}
        <Box
          sx={{
            position: "relative",
            "&:hover .slick-arrow": {
              opacity: 1,
            },
          }}
          onClick={() => {
            setSelectedUnit(unit);
            setIsGalleryOpen(true);
          }}
        >
          <Slider {...sliderSettings}>
            {getOrderedImages(unit).map((img, idx) => (
              <div key={idx}>
                <CardMedia
                  component="img"
                  image={img}
                  alt={`Unit ${idx + 1}`}
                  sx={{
                    height: 250,
                    objectFit: "cover",
                    cursor: "pointer",
                  }}
                />
              </div>
            ))}
          </Slider>

          {/* Fullscreen Button */}
          <IconButton
            sx={{
              position: "absolute",
              top: 8,
              right: 8,
              color: "white",
              bgcolor: "rgba(0,0,0,0.3)",
              "&:hover": {
                bgcolor: "rgba(0,0,0,0.5)",
              },
            }}
            onClick={() => {
              setSelectedUnit(unit);
              setIsGalleryOpen(true);
            }}
          >
            <FullscreenIcon />
          </IconButton>
        </Box>

        {/* Unit Details */}
        <CardContent
          sx={{
            flexGrow: 1,
            display: "flex",
            flexDirection: "column",
            gap: 1.5,
          }}
        >
          <Box
            // sx={{
            //   display: "flex",
            //   justifyContent: "space-between",
            // }}
            display="flex"
            justifyContent="space-between"
            alignItems="flex-start"
          >
            <Box
              sx={{
                //   display: "flex",
                //   justifyContent: "space-between",
                mb: 1,
              }}
            >
              <Typography variant="h6" component="h3">
                {unit.prefix}
                {unit.number}
              </Typography>
              <Typography variant="body1">{unit?.unitType?.name}</Typography>
            </Box>
          </Box>
          {/* <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              mb: 2,
            }}
          >
            <Typography variant="body1">{unit?.unitType?.name}</Typography>
          </Box> */}

          {/* <Box sx={{ display: "flex", gap: 2, mb: 2 }}>
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <BedIcon fontSize="small" sx={{ mr: 0.5 }} />
              <Typography variant="body2">
                {unit.unitType.occupancyCount
                  ? unit.unitType.occupancyCount
                  : getDisplayValue(unit.bedrooms, bedroomsArray)}
              </Typography>
            </Box>
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <BathtubIcon fontSize="small" sx={{ mr: 0.5 }} />
              <Typography variant="body2">
                {getDisplayValue(unit.bathroomType, bathroomTypeArray)}
              </Typography>
            </Box>
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <SquareFootIcon fontSize="small" sx={{ mr: 0.5 }} />
              <Typography variant="body2">{unit.size} sqft</Typography>
            </Box>
          </Box> */}

          {/* <Box
            sx={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <Box>
              <Typography variant="h6" color="inherit">
                {formattedPrice}
              </Typography>
            </Box>

            <Chip
              label={getDisplayValue(
                unit.paymentFrequency,
                paymentFrequencyArray
              )}
              color="inherit"
              sx={{ ml: 1 }}
            />
          </Box> */}

          <Stack
            direction="row"
            spacing={2}
            divider={<Divider orientation="vertical" flexItem />}
          >
            <Box display="flex" alignItems="center" gap={0.5}>
              <BedIcon fontSize="small" />
              <Typography variant="body2">
                {unit.unitType.occupancyCount
                  ? unit.unitType.occupancyCount
                  : getDisplayValue(unit.bedrooms, bedroomsArray)}
                {/* BHK */}
              </Typography>
            </Box>
            <Box display="flex" alignItems="center" gap={0.5}>
              <BathtubIcon fontSize="small" />
              <Typography variant="body2">
                {getDisplayValue(unit.bathroomType, bathroomTypeArray)}
              </Typography>
            </Box>
            <Box display="flex" alignItems="center" gap={0.5}>
              <SquareFootIcon fontSize="small" />
              <Typography variant="body2">{unit.size} sqft</Typography>
            </Box>
          </Stack>

          <Divider sx={{ borderStyle: "dashed" }} />

          {/* Pricing Row - The most important part */}
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Box>
              <Typography
                variant="caption"
                display="block"
                color="text.secondary"
              >
                Monthly Rent
              </Typography>
              <PriceDisplay
                unitPrice={unit.price}
                sx={{ fontWeight: "bold", fontSize: 20 }}
              />
            </Box>
            <Box textAlign="right">
              <Typography
                variant="caption"
                display="block"
                color="text.secondary"
              >
                Deposit
              </Typography>
              <PriceDisplay
                unitPrice={unit.securityDeposit}
                sx={{
                  fontWeight: "bold",
                  fontSize: 20,
                  color: "text.secondary",
                }}
              />
            </Box>
          </Box>
          <CommentTeaser variant="body2">
            {unit.comments || (
              <span style={{ color: "rgba(0,0,0,0.45)", fontStyle: "italic" }}>
                No description provided.
              </span>
            )}
          </CommentTeaser>
        </CardContent>

        {/* 3. Actions Footer - Stick to bottom */}
        <Box p={2} pt={0} display="flex" gap={1}>
          <Button
            variant="outlined"
            fullWidth
            startIcon={<InfoOutlined />}
            onClick={() => setDetailsOpen(true)}
          >
            Details
          </Button>
        </Box>
      </PropertyItem>

      {/* 1. The NEW Consolidated Details Dialog */}
      <UnitDetailsDialog
        open={detailsOpen}
        onClose={() => setDetailsOpen(false)}
        unit={unit}
        property={property}
        // key={unit.id}
      />

      {/* 1. Image Gallery Dialog */}
      <Dialog
        open={isGalleryOpen}
        onClose={() => setIsGalleryOpen(false)}
        maxWidth="lg"
        fullWidth
      >
        <DialogTitle>
          {unit?.unitType?.name} Gallery
          <IconButton
            sx={{ position: "absolute", right: 8, top: 8 }}
            onClick={() => setIsGalleryOpen(false)}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Slider {...dialogSliderSettings} initialSlide={activeImageIndex}>
            {selectedUnit &&
              getOrderedImages(selectedUnit).map((img, idx) => (
                <div key={idx}>
                  <CardMedia
                    component="img"
                    image={img}
                    alt={`Unit ${idx + 1}`}
                    sx={{ maxHeight: "70vh", objectFit: "contain" }}
                  />
                </div>
              ))}
          </Slider>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default PublicUnitCard;
